
export default {

  promotionEndDate: '2024-3-15 23:59:59'

}
